var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessionalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20082_117556",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.37439H20.1666V20.041H0.5V0.37439Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20082_117556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 5.57843C10.3333 7.62341 8.67553 9.28125 6.63047 9.28125C4.58533 9.28125 2.92761 7.62341 2.92761 5.57843C2.92761 3.53341 4.58533 1.87557 6.63047 1.87557C8.67553 1.87557 10.3333 3.53341 10.3333 5.57843Z",
    stroke: "#FE7A49",
    strokeWidth: 1.15234,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6305 9.28192C3.56296 9.28192 1.07617 11.7687 1.07617 14.8362V16.9962C1.07617 17.8448 1.7705 18.5391 2.61904 18.5391H10.6419C11.4905 18.5391 12.1848 17.8448 12.1848 16.9962V14.8362C12.1848 11.7687 9.69803 9.28192 6.6305 9.28192Z",
    stroke: "#FE7A49",
    strokeWidth: 1.15234,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.739 5.57843C17.739 7.62341 16.0812 9.28125 14.0361 9.28125C11.991 9.28125 10.3333 7.62341 10.3333 5.57843C10.3333 3.53341 11.991 1.87557 14.0361 1.87557C16.0812 1.87557 17.739 3.53341 17.739 5.57843Z",
    stroke: "#FE7A49",
    strokeWidth: 1.15234,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0248 18.5391H18.0476C18.8962 18.5391 19.5905 17.8448 19.5905 16.9962V14.8362C19.5905 11.7687 17.1037 9.28192 14.0362 9.28192C12.6136 9.28192 11.3158 9.81684 10.3331 10.6964",
    stroke: "#FE7A49",
    strokeWidth: 1.15234,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalIcon);
export default __webpack_public_path__ + "static/media/professional-icon.b317b25bbe30a07df3ca18761b5994cc.svg";
export { ForwardRef as ReactComponent };